import { Component, OnInit } from '@angular/core';
import { StorageService } from './services/storage.service';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from './services/settings.service';
import { Open311Service } from './services/open311.service';
import { SplashScreenService } from './services/splash-screen.service';
import { UpdateService } from './services/update.service';
import { ConfigService } from './services/config.service';
import { ThemeService } from './services/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private storageService: StorageService,
    private translate: TranslateService,
    private settingsSrv: SettingsService,
    private api: Open311Service,
    private splashScreen: SplashScreenService,
    private updateService: UpdateService,
    private configService: ConfigService,
    private themeService: ThemeService
  ) {}

  ngOnInit(): Promise<void> {
    return this.initializeApp();
  }

  private async initializeApp() {
    try {
      // Show splash screen first
      this.splashScreen.show();
      
      // Initialize storage
      await this.storageService.init();

      // Load configuration first as other services depend on it
      await this.configService.loadConfig();
      
      // Initialize splash screen with settings
      await this.splashScreen.init();
      
      // Load API settings and set language
      await this.api.loadSettings();
      await this.setLanguage();
      
      // Hide splash screen after a short delay to ensure animations are visible
      setTimeout(() => {
        this.splashScreen.hide();
      }, 1000);
    } catch (error) {
      console.error('Error initializing app:', error);
      // Make sure to hide splash screen even if there's an error
      this.splashScreen.hide();
    }
  }

  private async setLanguage() {
    const defaultLang = this.api.getDefaultLanguage() || 'fi';
    
    const settings = await this.settingsSrv.getSettings();
    const language = settings?.language || defaultLang;

    // Set up supported languages
    const supportedLanguages = this.api.getPreferredLanguages();
    this.translate.addLangs(supportedLanguages);

    this.translate.setDefaultLang(language);
    await this.translate.use(language).toPromise();
  }
}
